import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/CallConfig`;

/**
 * Initiates a call for a specific order line
 * @param {number} orderLineId - The order line ID to initiate a call for
 * @returns {Promise<Object>} - The result of the call initiation
 */
export const getCallConfigs = async () => {
  const endpoint = `${baseRoute}`;
  const headers = getHeaders();

  try {
    const response = await fetch(endpoint, {
      method: 'GET',
      headers,
    });

    const json = await response.json();
    return response.ok ? json : Promise.reject(json);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateCallConfigs = async (data) => {
  const endpoint = `${baseRoute}/batch`;
  const headers = getHeaders();

  try {
    const response = await fetch(endpoint, {
      method: 'PUT',
      headers,
      body: JSON.stringify(data),
    });

    const json = await response.json();
    return response.ok ? json : Promise.reject(json);
  } catch (error) {
    return Promise.reject(error);
  }
};
